import { Component, Inject } from '@angular/core';
import { Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FicheConseilService } from 'src/app/services/fiche-conseil.service';
import { FormConfigService } from 'src/app/services/form-config.service';
import { FieldFormControl } from 'src/fieldFormControl/FieldFormControl';
@Component({
  selector: 'app-renommer-fiche-dialog',
  templateUrl: './renommer-fiche-dialog.component.html',
  styleUrls: ['./renommer-fiche-dialog.component.scss'],
})
export class RenommerFicheDialogComponent {
  isloading: boolean;
  labelControl: FieldFormControl<string | null, string | null>;
  isSaving: boolean;

  constructor(
    protected ficheConseilService: FicheConseilService,
    protected formConfigService: FormConfigService,
    @Inject(MAT_DIALOG_DATA)
    private data: { ficheId: string },
    private dialogRef: MatDialogRef<RenommerFicheDialogComponent>
  ) {}

  ngOnInit(): void {
    this.isloading = true;
    this.ficheConseilService.onFicheIdSelected(this.data.ficheId);
    this.labelControl = new FieldFormControl<string | null, string | null>({
      formConfigService: this.formConfigService,
      ficheConseilService: this.ficheConseilService,
      ficheDataToFieldDataWrapper: (ficheData: string) =>
        ficheData ?? this.ficheConseilService.getCurrentFicheConseilLabel(),
      fieldDataToFicheDataWrapper(fieldData) {
        return fieldData;
      },
      dataKey: 'libelle',
      defaultValue: '',
      options: { validators: [Validators.required] },
    });
    this.ficheConseilService.currentFicheConseilSubject.subscribe(currentFiche => {
      if (currentFiche) {
        this.isloading = false;
      }
    });
  }

  onValid() {
    this.isSaving = true;
    this.ficheConseilService.pushFicheConseilDataToBackEnd().then(hasBeenSaved => {
      this.isSaving = false;
      this.dialogRef.close(hasBeenSaved);
    });
  }
}
